<template>
  <div class="mask" v-if="show">
    <div class="window sgl-aligncenter scalein">
      <SglImage
        :src="require('@/assets/images/popup/bg.png')"
        :width="932"
        :height="1292"
        class="sgl-aligncenter"
      >
        <div class="content sgl-aligncenter">
          <SglImage
            :src="photoUrl"
            :width="416"
            :height="416"
            class="sgl-center"
            @click="previewPhotoUrl"
          >
            <div
              :style="{
                position: 'absolute',
                bottom: 'calc(2 * var(--app-vw))',
                right: 'calc(2 * var(--app-vw))',
                color: '#fdf3a6',
                'background-color': '#ff863e',
                padding: 'calc(1 * var(--app-vw))',
                'border-radius': '1000px',
                'text-align': 'center',
                'font-size': '0.9rem',
              }"
            >
              {{ player.no < 10 ? "0" + player.no : player.no }}
            </div>
          </SglImage>
          <div
            class="line-1"
            :style="{
              'text-align': '-webkit-center',
              width: 'calc(60 * var(--app-vw))',
              'max-width': 'calc(60 * var(--app-vw))',
              'margin-top': '0.5rem',
              position: 'relative',
              height: '1.5rem',
            }"
            v-if="player.name.length < 15"
          >
            <p
              :style="{
                'font-size': '1rem',
                'text-align': '-webkit-center',
                width: 'fit-content',
                'max-width': '100%',
                margin: 'calc(1 * var(--app-vw)) 0',
                'line-height': '1em',
              }"
            >
              {{ player.name }}
            </p>
          </div>
          <div
            class="line-1"
            :style="{
              'text-align': '-webkit-center',
              width: 'calc(60 * var(--app-vw))',
              'max-width': 'calc(60 * var(--app-vw))',
              'margin-top': '0.5rem',
              position: 'relative',
              height: '1.5rem',
            }"
            v-else
          >
            <p
              :style="{
                'font-size': '1rem',
                'text-align': '-webkit-center',
                width: 'fit-content',
                'max-width': '100%',
                margin: 'calc(1 * var(--app-vw)) 0',
                position: 'absolute',
                animation: getAnimation(),
                'line-height': '1em',
                height: '1.5rem',
              }"
            >
              {{ player.name }}
            </p>
          </div>

          <SglImage
            :src="require('@/assets/images/popup/music.gif')"
            :width="491"
            :height="67"
            class="sgl-center"
            @click="changeMusic"
            style="margin-top: 0.3rem"
            v-if="musicUrl && musicPlay"
          >
          </SglImage>
          <SglImage
            :src="require('@/assets/images/popup/music.png')"
            :width="491"
            :height="67"
            class="sgl-center"
            @click="changeMusic"
            style="margin-top: 0.3rem"
            v-if="musicUrl && !musicPlay"
          >
          </SglImage>
          <div
            ref="scrollbar"
            :style="{
              position: 'absolute',
              top: top,
              right: 'calc(10 * var(--app-vw))',
              width: 'calc(1 * var(--app-vw))',
              height: 'calc(12 * var(--app-vw))',
              'margin-top': 'calc(59 * var(--app-vw))',
              'background-color': '#bfbfbf',
              'border-radius': 'calc(1 * var(--app-vw))',
              transition: 'top 0.01s',
              'z-index': 21,
            }"
            v-if="musicUrl"
          ></div>
          <div
            ref="scrollbar"
            :style="{
              position: 'absolute',
              top: top,
              right: 'calc(10 * var(--app-vw))',
              width: 'calc(1 * var(--app-vw))',
              height: 'calc(12 * var(--app-vw))',
              'margin-top': 'calc(51 * var(--app-vw))',
              'background-color': '#bfbfbf',
              'border-radius': 'calc(1 * var(--app-vw))',
              transition: 'top 0.01s',
              'z-index': 21,
            }"
            v-else
          ></div>
          <div
            ref="contentD"
            class="contentD hiddenscroll"
            style="
              text-align: justify;
              font-size: 0.8rem;
              overflow-y: auto;
              margin-top: 0.4rem;
            "
            :style="{
              height: musicUrl
                ? 'calc(var(--app-vw) * 31)'
                : 'calc(var(--app-vw) * 39)',
              'max-height': musicUrl
                ? 'calc(var(--app-vw) * 31)'
                : 'calc(var(--app-vw) * 39)',
            }"
            @scroll="scrollHandle"
          >
            {{ player.intro }}
          </div>

          <div class="sgl-flex" style="margin-top: 0.8rem">
            <SglImage
              :src="require('@/assets/images/popup/lightbtn.png')"
              :width="269"
              :height="79"
              style="margin-right: 2rem"
              @click="vote"
            >
            </SglImage>
            <SglImage
              :src="require('@/assets/images/popup/sharebtn.png')"
              :width="269"
              :height="79"
              @click="showShareBg"
            >
            </SglImage>
          </div>
        </div>
      </SglImage>
      <SglImage
        :src="require('@/assets/images/popup/close.png')"
        :width="80"
        :height="80"
        class="sgl-center"
        style="margin-top: 1rem"
        @click="close"
      >
      </SglImage>
    </div>
  </div>
</template>

<script>
import { ImagePreview } from "vant";

export default {
  name: "SiguileCszx2025H5DetailPopupUp",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    player: {
      type: Object,
      default: {},
    },
    musicPlay: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show: {
      handler(val) {
        if (val) {
          setTimeout(() => {
            this.top = "calc(10 * var(--app-vw))";
          }, 100);
        }
        if (val && this.musicUrl) {
          this.$emit("playMusic", this.musicUrl);
        }
      },
      immediate: true,
    },
  },

  computed: {
    avatarUrl() {
      if (this.player && this.player.avatar) {
        return this.player.filePrefix + this.player.avatar;
      }
      return null;
    },
    photoUrl() {
      if (this.player && this.player.photo) {
        return this.player.filePrefix + this.player.photo;
      }
      return null;
    },
    previewUrl() {
      if (this.player && this.player.preview) {
        return this.player.filePrefix + this.player.preview;
      }
      return null;
    },
    musicUrl() {
      if (this.player && this.player.music) {
        return this.player.filePrefix + this.player.music;
      }
      return null;
    },
  },
  data() {
    return {
      top: "calc(10 * var(--app-vw))",
    };
  },

  mounted() {},

  methods: {
    scrollHandle(e) {
      if (!this.$refs.contentD || !this.$refs.scrollbar) {
        this.top = "calc(10 * var(--app-vw))";
        return;
      }
      let availableScrollHeight =
        this.$refs.contentD.scrollHeight - this.$refs.contentD.clientHeight;
      if (availableScrollHeight <= 0) {
        this.$refs.scrollbar.style.opacity = 0;
        this.top = "calc(10 * var(--app-vw))";
        return;
      }
      this.$refs.scrollbar.style.opacity = 1;
      let top =
        ((Math.min(
          Number(this.$refs.contentD.scrollTop.toFixed(2)) /
            availableScrollHeight,
          1
        ) *
          (this.$refs.contentD.clientHeight -
            this.$refs.scrollbar.clientHeight)) /
          document.getElementById("app").clientWidth) *
        100;
      this.top = "calc(" + (top + 10) + " * var(--app-vw))";
    },

    getAnimation() {
      let res =
        "nameRoll-" +
        this.player.name.length +
        " " +
        this.player.name.length / 5 +
        "s linear infinite";
      console.log("12312321", res);
      return res;
    },
    changeMusic() {
      if (this.musicUrl) {
        this.$emit("changeMusic", this.musicUrl);
      }
    },
    previewPhotoUrl() {
      if (!this.previewUrl) {
        return;
      }
      ImagePreview({
        images: [this.previewUrl],
        showIndicators: true,
        closeable: true,
      });
    },

    close() {
      this.$emit("close");
    },
    showShareBg() {
      this.$emit("showShareBg");
    },
    vote() {
      this.$emit("vote", this.player.id);
    },
  },
};
</script>

<style scoped>
.mask {
  position: fixed;
  left: 0;
  top: 0;
  height: 100vh;
  width: 100vw;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 35;
}

.window {
  background-size: 100vw 100vh;
  background-repeat: no-repeat;
  position: relative;
  overflow-y: visible;
}

.content {
  width: calc(var(--app-vw) * 65);
  text-align: justify;
  font-size: 1.5rem;
  color: #231815;
  overflow-y: hidden;
  margin-top: calc(var(--app-vw) * 14);
  margin-right: calc(var(--app-vw) * 3);
  /* background: blue; */
}

.content p {
  font-size: 1.5rem;
  color: #231815;
}

.line-1 {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>


// WEBPACK FOOTER //
// src/components/DetailPopupUp.vue